import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestCardTypeList = () => {
  const getUrl = '/user/card_type';

  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export default requestCardTypeList;
